import { Component, Input } from '@angular/core';
import { UICallHistoryItem } from '../../../models/company-call-history/company-call-history.model';
import { UtilsService } from '../../../services';

@Component({
  selector: 'ai-list',
  templateUrl: './ai-list.component.html',
  styleUrls: [
    './ai-list.component.scss',
    '../company-call-history-common-list-style.scss'
  ]
})
export class AiListComponent {

  @Input() callItem: UICallHistoryItem;

  public summaryCopyText: string = 'events.company-call-history.detail.ai.copy-text.copy';
  public transcriptionCopyText: string = 'events.company-call-history.detail.ai.copy-text.copy';

  constructor(
    private utilsService: UtilsService
  ){}


  public copy(text: string, isSummary: boolean) {
    this.utilsService.copyToClipboardWithAPI(text).then();
    if(isSummary) {
        this.summaryCopyText = 'events.company-call-history.detail.ai.copy-text.copied';
        setTimeout(() => {
            this.summaryCopyText = 'events.company-call-history.detail.ai.copy-text.copy';
        },3000);
    } else {
      this.transcriptionCopyText = 'events.company-call-history.detail.ai.copy-text.copied';
      setTimeout(() => {
          this.transcriptionCopyText = 'events.company-call-history.detail.ai.copy-text.copy';
      },3000);
    }
  }
}
